import { useState, useEffect } from 'react'
import { clientApi } from '../../services/clientApi'

const AVAILABLE_GROUPS = [
  { id: 'geocontexte-viewer', label: 'Viewer (lecture seule)' },
  { id: 'geocontexte-operator', label: 'Operator (edition)' },
  { id: 'geocontexte-admin', label: 'Admin (gestion complete)' },
]

interface Props {
  clientId: string
  userId: string
  onClose: () => void
}

export default function UserGroupAssignment({ clientId, userId, onClose }: Props) {
  const [groups, setGroups] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const data = await clientApi.getUserGroups(clientId, userId)
        setGroups(data)
      } catch {
        setGroups([])
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [clientId, userId])

  const toggle = (groupId: string) => {
    setGroups((prev) =>
      prev.includes(groupId) ? prev.filter((g) => g !== groupId) : [...prev, groupId]
    )
  }

  const handleSave = async () => {
    setSaving(true)
    setError(null)
    try {
      await clientApi.setUserGroups(clientId, userId, groups)
      onClose()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur sauvegarde')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="admin-modal__overlay" onClick={onClose}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Permissions utilisateur</h3>
        {loading ? (
          <p className="admin-loading">Chargement...</p>
        ) : (
          <div className="admin-groups">
            {AVAILABLE_GROUPS.map((g) => (
              <label key={g.id}>
                <input
                  type="checkbox"
                  checked={groups.includes(g.id)}
                  onChange={() => toggle(g.id)}
                />
                {g.label}
              </label>
            ))}
          </div>
        )}
        {error && <div className="admin-error">{error}</div>}
        <div className="admin-form__actions">
          <button className="admin-btn" onClick={onClose}>Annuler</button>
          <button className="admin-btn admin-btn--create" onClick={handleSave} disabled={saving}>
            {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </button>
        </div>
      </div>
    </div>
  )
}
